import __regexp from './__edge-regexp';
/** Detect Microsoft Edge Browser */
export default function isEdge(ua) {
	return __regexp.test(ua);
}
